var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 4.73267C15.5509 4.73267 14.6408 5.10968 13.9697 5.78076L12.9728 6.7776C12.9718 6.77865 12.9707 6.7797 12.9697 6.78076C12.9686 6.78182 12.9675 6.78288 12.9665 6.78395L3.46967 16.2808C3.32902 16.4214 3.25 16.6122 3.25 16.8111V20.8111C3.25 21.2253 3.58579 21.5611 4 21.5611H8C8.19891 21.5611 8.38968 21.4821 8.53033 21.3414L18.0303 11.8414L19.0303 10.8414C19.7014 10.1703 20.0784 9.26015 20.0784 8.31109C20.0784 7.36204 19.7014 6.45185 19.0303 5.78076C18.3592 5.10968 17.4491 4.73267 16.5 4.73267ZM17.5 10.2504L17.9697 9.78076C18.3595 9.39098 18.5784 8.86233 18.5784 8.31109C18.5784 7.75986 18.3595 7.2312 17.9697 6.84142C17.5799 6.45164 17.0512 6.23267 16.5 6.23267C15.9488 6.23267 15.4201 6.45164 15.0303 6.84142L14.5607 7.3111L17.5 10.2504ZM13.5 8.37176L16.4393 11.3111L7.68934 20.0611H4.75V17.1218L13.5 8.37176Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIcon);
export default __webpack_public_path__ + "static/media/pen_icon.50f3b3378ea3efa94f146e8372f203f9.svg";
export { ForwardRef as ReactComponent };